import moment from "moment/moment";

const time = {
    namespaced: true,
    state: () => ({
        currentlySelectedMonth: undefined
    }),
    getters: {
        currentlySelectedMonth: state => state.currentlySelectedMonth
    },
    mutations: {
        initializeCurrentlySelectedMonth(state, payload){
            state.currentlySelectedMonth = moment(payload);
        },
        addMonth(state) {
            state.currentlySelectedMonth = moment(this.state.time.currentlySelectedMonth).add(1, "month");
        },
        subtractMonth(state) {
            state.currentlySelectedMonth = moment(this.state.time.currentlySelectedMonth).subtract(1, "month");
        },
    }
};
export default time;